// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .event {
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: white;
  color: #000;
}
.theme-light .event .container {
  padding: 20px;
}
.theme-light .event .container .user {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.theme-light .event .container .user .userInfo {
  display: flex;
  gap: 20px;
}
.theme-light .event .container .user .userInfo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-light .event .container .user .userInfo .details {
  display: flex;
  flex-direction: column;
}
.theme-light .event .container .user .userInfo .details .name {
  font-weight: 500;
}
.theme-light .event .container .user .userInfo .details .date {
  font-size: 12px;
}
.theme-light .event .container .content {
  margin: 20px 0px;
}
.theme-light .event .container .content img {
  width: 100%;
  max-height: 500px;
  object-fit: cover;
  margin-top: 20px;
}
.theme-light .event .container .info {
  display: flex;
  align-items: center;
  gap: 20px;
}
.theme-light .event .container .info .item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
}
.theme-dark .event {
  box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);
  border-radius: 20px;
  background-color: #222;
  color: #fffef9;
}
.theme-dark .event .container {
  padding: 20px;
}
.theme-dark .event .container .user {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.theme-dark .event .container .user .userInfo {
  display: flex;
  gap: 20px;
}
.theme-dark .event .container .user .userInfo img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
.theme-dark .event .container .user .userInfo .details {
  display: flex;
  flex-direction: column;
}
.theme-dark .event .container .user .userInfo .details .name {
  font-weight: 500;
}
.theme-dark .event .container .user .userInfo .details .date {
  font-size: 12px;
}
.theme-dark .event .container .content {
  margin: 20px 0px;
}
.theme-dark .event .container .content img {
  width: 100%;
  max-height: 500px;
  object-fit: cover;
  margin-top: 20px;
}
.theme-dark .event .container .info {
  display: flex;
  align-items: center;
  gap: 20px;
}
.theme-dark .event .container .info .item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/event/event.scss"],"names":[],"mappings":"AAqBI;ECfA,kDAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAFJ;AAII;EACE,aAAA;AAFN;AAIM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAFR;AAIQ;EACE,aAAA;EACA,SAAA;AAFV;AAIU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAFZ;AAKU;EACE,aAAA;EACA,sBAAA;AAHZ;AAKY;EACE,gBAAA;AAHd;AAMY;EACE,eAAA;AAJd;AAUM;EACE,gBAAA;AARR;AAUQ;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AARV;AAYM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAVR;AAYQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AAVV;ADnCI;ECfA,kDAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAuDJ;AArDI;EACE,aAAA;AAuDN;AArDM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAuDR;AArDQ;EACE,aAAA;EACA,SAAA;AAuDV;AArDU;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAuDZ;AApDU;EACE,aAAA;EACA,sBAAA;AAsDZ;AApDY;EACE,gBAAA;AAsDd;AAnDY;EACE,eAAA;AAqDd;AA/CM;EACE,gBAAA;AAiDR;AA/CQ;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAiDV;AA7CM;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA+CR;AA7CQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,eAAA;AA+CV","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.event {\n  @include themify($themes) {\n    -webkit-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n    -moz-box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n    box-shadow: 0px 0px 25px -10px rgba(0, 0, 0, 0.38);\n    border-radius: 20px;\n    background-color: themed(\"bg\");\n    color: themed(\"textColor\");\n\n    .container {\n      padding: 20px;\n\n      .user {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n\n        .userInfo {\n          display: flex;\n          gap: 20px;\n\n          img {\n            width: 40px;\n            height: 40px;\n            border-radius: 50%;\n            object-fit: cover;\n          }\n\n          .details {\n            display: flex;\n            flex-direction: column;\n\n            .name {\n              font-weight: 500;\n            }\n\n            .date {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n\n      .content {\n        margin: 20px 0px;\n\n        img {\n          width: 100%;\n          max-height: 500px;\n          object-fit: cover;\n          margin-top: 20px;\n        }\n      }\n\n      .info {\n        display: flex;\n        align-items: center;\n        gap: 20px;\n\n        .item {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          cursor: pointer;\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
